export type MioTheme = 'white' | 'black' | 'blue' | 'pink'
export type MioScale = 67 | 80 | 90 | 100 | 110 | 125 | 140

const THEME_KEY = 'mio.mio_segno.ui.displayTheme'
const SCALE_KEY = 'mio.mio_segno.ui.displayScale'
const SCALES: MioScale[] = [67, 80, 90, 100, 110, 125, 140]

export function currentTheme(): MioTheme {
  const value = localStorage.getItem(THEME_KEY)
  return value === 'black' || value === 'blue' || value === 'pink' ? value : 'white'
}

export function currentScale(): MioScale {
  const value = Number(localStorage.getItem(SCALE_KEY))
  return SCALES.includes(value as MioScale) ? value as MioScale : 100
}

export function applyTheme(theme: MioTheme): void {
  document.documentElement.dataset.mioTheme = theme
  localStorage.setItem(THEME_KEY, theme)
  const themeColor = theme === 'black' ? '#0d1219' : theme === 'blue' ? '#dcecff' : theme === 'pink' ? '#f9e4ec' : '#f5f6fa'
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', themeColor)
}

export function applyScale(scale: MioScale): void {
  const normalized = scale / 100
  const viewport = window.visualViewport
  const width = document.documentElement.clientWidth || viewport?.width || window.innerWidth
  const height = viewport?.height ?? window.innerHeight
  const root = document.documentElement
  root.dataset.mioScale = String(scale)
  root.style.setProperty('--mio-ui-scale', String(normalized))
  root.style.setProperty('--mio-ui-width', `${width / normalized}px`)
  root.style.setProperty('--mio-ui-height', `${height / normalized}px`)
  localStorage.setItem(SCALE_KEY, String(scale))
  requestAnimationFrame(() => {
    const top = window.scrollY
    window.scrollTo({ left: 0, top, behavior: 'auto' })
    document.documentElement.scrollLeft = 0
    document.body.scrollLeft = 0
  })
}

export function bindScaleToViewport(): () => void {
  const listener = () => applyScale(currentScale())
  window.addEventListener('resize', listener)
  window.visualViewport?.addEventListener('resize', listener)
  return () => {
    window.removeEventListener('resize', listener)
    window.visualViewport?.removeEventListener('resize', listener)
  }
}
